export const QueryParamRegistration = 'registration'
export const QueryParamVIN = 'vin'

// queryParamFromVehicleSearchText returns a queryParam string for the registration OR the VIN.
// this takes a best-guess approach based on search-string length: >=12 char, most likely a vin
// return empty string for empty input
// example:  queryParamFromVehicleSearchText("32-hl-bk") =>  "registration=32-hl-bk"
export const queryParamFromVehicleSearchText = (s: string) => {
  if (!s) {
    return ''
  }
  if (s.length >= 12) {
    return `${QueryParamVIN}=${s.substring(0, 17)}`
  }
  return `${QueryParamRegistration}=${s}`
}
